<template name="u-xzzz">
  <div class="sxxzq">
    <van-field
      v-bind="$attrs"
      @click="clickOpen"
      :input-align="inputAlign"
      v-model="name"
      :placeholder="placeholder"
      readonly
      clickable
      right-icon="arrow-down"
      :border="true"
    />
    <van-popup v-model="show" position="bottom">
      <van-picker
        ref="picker"
        show-toolbar
        :columns="dataList"
        @confirm="onConfirm"
        @cancel="show = false"
        value-key="title"
      />
    </van-popup>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  name: 'u-xzzz',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    list: {
      type: Array,
      default() {
        return []
      },
    },
    ifNetData: {
      type: Boolean,
      default: true,
    },
    defValue: {
      type: String,
      default: '',
    },
    inputAlign: {
      type: String,
      default: 'right',
    },
    dictCode: String,
  },
  created() {
    this.getData()
  },
  data() {
    return {
      show: false,
      dataList: this.list,
      name: '',
      myValue: this.value,
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.dataList = this.list
      },
    },
    defValue: {
      immediate: true,
      handler() {
        this.name = this.defValue
      },
    },
    myValue(newVal) {
      this.$emit('input', newVal)
    },
  },
  methods: {
    onConfirm(value, indexArr) {
      this.show = false
      try {
        if (indexArr instanceof Array) {
          this.myValue = this.getValueByIndex(indexArr)
          this.name = value.join('-')
        }
      } catch (error) {}
    },
    getValueByIndex(indexArr) {
      let arr = [...this.dataList]
      let value = ''
      indexArr.map((index, i) => {
        let obj = arr[index]
        if (indexArr.length - 1 == i) {
          value = obj.orgCode
        } else {
          arr = obj.children
        }
      })
      return value
    },
    getData() {
      let params = { category: '2' }
      let url = '/sys/sysDepart/queryTreeList/by/category/xzzz'
      getAction(url, params).then((res) => {
        if (res.success) {
          let list = res.result
          this.dataList = list
          if (this.value) {
            let code = this.value
            this.name = this.getNameByCode(code)
          }
        }
      })
    },
    getNameByCode(code) {
      let xcode = code.substr(0, 3)
      let zcode = code.substr(0, 6)
      let xobj = this.dataList.find((obj) => obj.orgCode == xcode)
      let zObj = xobj.children.find((obj) => obj.orgCode == zcode)
      let cObj = zObj.children.find((obj) => obj.orgCode == code)
      let name = xobj.title + '-' + zObj.title + '-' + cObj.title
      return name
    },
    clickOpen() {
      this.show = true
      this.$nextTick(() => {
        let arr = this.name.split('-')
        this.$refs.picker.setValues(arr)
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>
